module.exports = __webpack_public_path__ + "static/media/background.e10c772f.svg";